import { FC } from "react";
import st from './staffCard.module.scss';

interface StaffCardProps {
    icon: JSX.Element
    text: JSX.Element
}

const StaffCard: FC<StaffCardProps> = ({icon, text}) => {
    return (
        <div className={st['staff-card']}>
            <div className={st['staff-card__icon']}>{icon}</div>
            <p className={st['staff-card__text']}>{text}</p>
        </div>
    );
};

export default StaffCard;